import {
  FEEDBACK_CATEGORIES,
  FEEDBACK_STATUSES,
  type FeedbackFilter,
  type FeedbackScope,
  type FeedbackSort,
} from '@/entities/feedback';

const SORTS: readonly FeedbackSort[] = [
  'activity_desc',
  'activity_asc',
  'created_desc',
  'created_asc',
];

export const DEFAULT_SORT: FeedbackSort = 'activity_desc';

/** The list state lives in the address (Back/Forward and shared links keep filters). */
export function filterFromParams(params: URLSearchParams, allowAll: boolean): FeedbackFilter {
  const scope: FeedbackScope = allowAll && params.get('tab') === 'all' ? 'all' : 'mine';
  // `status` repeats: `?status=received&status=planned`; a single value is the old single-status link
  const statuses = FEEDBACK_STATUSES.filter((s) => params.getAll('status').includes(s));
  const category = params.get('category');
  const sort = params.get('sort');
  return {
    scope,
    q: params.get('q') ?? '',
    statuses,
    category: FEEDBACK_CATEGORIES.find((c) => c === category) ?? '',
    sort: SORTS.find((s) => s === sort) ?? DEFAULT_SORT,
    assigned: scope === 'all' ? (params.get('assigned') ?? '') : '',
    attention: scope === 'all' && params.get('attention') === '1',
    unread: params.get('unread') === '1',
  };
}

export function paramsFromFilter(filter: FeedbackFilter): URLSearchParams {
  const params = new URLSearchParams();
  if (filter.scope === 'all') params.set('tab', 'all');
  if (filter.q.trim()) params.set('q', filter.q);
  for (const status of filter.statuses) params.append('status', status);
  if (filter.category) params.set('category', filter.category);
  if (filter.sort !== DEFAULT_SORT) params.set('sort', filter.sort);
  if (filter.assigned) params.set('assigned', filter.assigned);
  if (filter.attention) params.set('attention', '1');
  if (filter.unread) params.set('unread', '1');
  return params;
}

export function hasActiveFilters(filter: FeedbackFilter): boolean {
  return Boolean(
    filter.q.trim() ||
    filter.statuses.length > 0 ||
    filter.category ||
    filter.assigned ||
    filter.attention ||
    filter.unread,
  );
}
